<template>

  <el-row :gutter="5">
    <el-col :span="4"></el-col>
    <el-col :span="16"><h2 class="heading">Broker Statement List</h2></el-col>
    <el-col :span="4"><el-button style="margin-top:20px;" @click="$router.push('/broker/editBrokerStatement')" >
            <el-icon><Plus/></el-icon> &nbsp; Add Broker Statement</el-button></el-col>
  </el-row>

  <el-table :data="brokerStateList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="id" label="ID" align="center" width="60" sortable="custom" />
    <el-table-column prop="title" label="Title" width="300" sortable="custom" />
    <el-table-column prop="yyyymm" label="YYYY-MM" sortable="custom" align="center" />
    <el-table-column prop="requester" label="Requester" sortable="custom" />
    <el-table-column prop="createTime" label="Create Time" align="center" width="150" sortable="custom" />
    <el-table-column prop="remarks" label="Remarks" sortable="custom"/>
    <el-table-column prop="checked" label="Check" align="center">
        <template #default="scope">
            <el-icon :size="20"  v-if="scope.row.checked=='Yes'" title="Click to check" @click="checkBrokerState(scope.row)" >
                <CircleCheckFilled />
            </el-icon>
            <el-icon :size="20" v-else title="Click to uncheck" @click="checkBrokerState(scope.row)" >
                <CircleCheck style="color:#ccc;" />
            </el-icon>
        </template>
    </el-table-column>
    <el-table-column prop="checkTime" label="Check Time" align="center"></el-table-column>
    <el-table-column prop="checked" label="Action" align="center">
        <template #default="scope">
            <el-icon :size="16" @click="$router.push('/broker/editBrokerStatement?code=' + scope.row.idMd5)" title="Edit" class="op">
                <Edit />
            </el-icon>
            <el-icon :size="16" v-if="scope.row.checked=='No'" @click="deleteBrokerState(scope.row.idMd5)" title="Delete" class="op">
                <Delete />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :current-page="page.currPage"
    @current-change="getBrokerStatementList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete, Edit, CircleCheckFilled, CircleCheck, Plus } from '@element-plus/icons-vue'

export default {
    components: {
        Delete, CircleCheckFilled, CircleCheck, Edit, Plus
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            brokerStateList: [],
            page: {currPage: 1},
            global,
        }
    },
    async mounted() {
        this.global.index = "investment";
        this.getBrokerStateList(1);
    },
    methods: {
        async getBrokerStateList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo: pageNo};
            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }
            let result = await AXIOS("/broker/allBrokerStatements", data);
            if (result.success) {
                this.brokerStateList = result.data.list;
                this.page = result.data.page;
            } else {
                console.log(result.errMsg);
            }
        },
        async checkBrokerState(brokeState) {
            let action = brokeState.checked == "No" ? "check" : "uncheck";
            let data = {action: action, code : brokeState.idMd5};
            let result = await AXIOS("/broker/checkBrokerStatement", data);
            if (result.success) {
                let state = result.data;
                console.log("state===="+state);
                brokeState.checked = state.checked;
                brokeState.checkTime = state.checkTime;
            }
        },
        async deleteBrokerState(code) {
            ElMessageBox.confirm(
                'Are you sure want to delete this broker statement?',  'Warning',
                { cancelButtonText: ' No ', confirmButtonText: ' Yes ', type: 'warning', }
            ).then(async () => {
                let result = await AXIOS("/broker/deleteBrokerStatement", {code:code});
                if (result.success) {
                    this.brokerStateList.splice(this.brokerStateList.findIndex(e => e.idMd5 == code), 1);
                    ElMessage({
                        message: 'Deleted broker statement successfully!',
                        type: 'success',
                    });
                }
            })
        },
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.getBrokerStateList(1);
        },
        tableRowClassName(scope) {
            return scope.row.checked;
        }
    }
}
</script>

<style>
</style>